import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
} from "@mui/material";
import { Add, Edit, Delete, Close } from "@mui/icons-material";
import "./SalaryRevision.css";

const emptyForm = {
  id: "",
  employeeName: "",
  oldCTC: "",
  newCTC: "",
  changes: "",
  effectiveDate: "",
};

const SalaryRevision = () => {
  const [data, setData] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [open, setOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const openModal = (row = null, index = null) => {
    setForm(row || emptyForm);
    setEditIndex(index);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setForm(emptyForm);
    setEditIndex(null);
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    if (Object.values(form).some((v) => v === "")) {
      alert("All fields are required");
      return;
    }

    if (editIndex !== null) {
      const updated = [...data];
      updated[editIndex] = form;
      setData(updated);
    } else {
      setData([...data, form]);
    }
    closeModal();
  };

  const handleDelete = (index) => {
    if (window.confirm("Delete this salary revision?")) {
      setData(data.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="revision-wrapper">
      <div className="revision-card">
        <div className="revision-header">
          <h2>Salary Revision</h2>
          <Button
            className="revision-add-btn"
            startIcon={<Add />}
            onClick={() => openModal()}
          >
            Add Revision
          </Button>
        </div>

        <TableContainer component={Paper} className="revision-table">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>ID</TableCell>
                <TableCell>Employee Name</TableCell>
                <TableCell>Old CTC</TableCell>
                <TableCell>New CTC</TableCell>
                <TableCell>Changes</TableCell>
                <TableCell>Effective Date</TableCell>
                <TableCell align="center">Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.employeeName}</TableCell>
                  <TableCell>₹ {row.oldCTC}</TableCell>
                  <TableCell className="highlight">₹ {row.newCTC}</TableCell>
                  <TableCell>{row.changes}</TableCell>
                  <TableCell>{row.effectiveDate}</TableCell>
                  <TableCell align="center">
                    <IconButton
                      color="warning"
                      onClick={() => openModal(row, index)}
                    >
                      <Edit />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(index)}
                    >
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}

              {!data.length && (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No salary revision records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* MODAL */}
      <Modal open={open} onClose={closeModal}>
        <Box className="revision-modal">
          <div className="modal-header">
            <h3>Salary Revision Entry</h3>
            <IconButton onClick={closeModal}>
              <Close />
            </IconButton>
          </div>

          <div className="modal-grid">
            <TextField
              label="Employee ID"
              name="id"
              value={form.id}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Employee Name"
              name="employeeName"
              value={form.employeeName}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Old CTC"
              name="oldCTC"
              value={form.oldCTC}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="New CTC"
              name="newCTC"
              value={form.newCTC}
              onChange={handleChange}
              size="small"
            />
            <TextField
              label="Changes"
              name="changes"
              value={form.changes}
              onChange={handleChange}
              size="small"
            />
            <TextField
              type="date"
              label="Effective Date"
              name="effectiveDate"
              value={form.effectiveDate}
              onChange={handleChange}
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </div>

          <Button className="revision-save-btn" onClick={handleSave}>
            Save
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default SalaryRevision;
